import { ApiFormattedResponse } from "@models/api_formatted_response"
import { mutate, query } from "@utils/graphql"
import {
  CallAdminLog,
  CallAdminLogDetailResponse,
  CallAdminLogsResponse,
  DeleteCallAdminLogsInput,
  DeleteCallAdminLogsResponse,
  GetCallAdminLogsInput
} from "__generated__/graphql"
import deleteCallAdminLogs from "__generated__/queries/mutations/deleteCallAdminLogs"
import getCallAdminLogDetail from "__generated__/queries/queries/getCallAdminLogDetail"
import getCallAdminLogs from "__generated__/queries/queries/getCallAdminLogs"

export async function listCallAdminLogsQuery(
  params: GetCallAdminLogsInput
): Promise<ApiFormattedResponse<CallAdminLogsResponse["data"]>> {
  const response = await query<{
    getCallAdminLogs?: CallAdminLogsResponse
  }>({
    query: getCallAdminLogs,
    variables: {
      params
    }
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }
  return {
    isSuccess: true,
    data: response?.data?.getCallAdminLogs?.data
  }
}

export async function getCallAdminLogDetailQuery(
  callSid: string
): Promise<ApiFormattedResponse<CallAdminLog>> {
  const response = await query<{
    getCallAdminLogDetail?: CallAdminLogDetailResponse
  }>({
    query: getCallAdminLogDetail,
    variables: { callSid }
  })

  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }

  return {
    isSuccess: true,
    data: response?.data?.getCallAdminLogDetail?.data || undefined
  }
}

export async function deleteCallAdminLogsMutation(
  params: DeleteCallAdminLogsInput
): Promise<ApiFormattedResponse<DeleteCallAdminLogsResponse["data"]>> {
  const response = await mutate<{
    deleteCallAdminLogs?: DeleteCallAdminLogsResponse
  }>({
    mutation: deleteCallAdminLogs,
    variables: {
      params
    }
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }
  return {
    isSuccess: true,
    data: response?.data?.deleteCallAdminLogs?.data
  }
}
